module.exports = __webpack_public_path__ + "static/thumbnail-0d14de30dd11656903d46dc8311621c6.png";